module.exports = __webpack_public_path__ + "static/img/bg_line.27f135a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/bg_line.png
// module id = X1z9
// module chunks = 8